<template>
    <div
        class="frame"
        id="frame"
        :tabindex="tabIndex"
        @keydown="onKeyDown"
    >
        <ul class="clearfix" role="listbox">
            <li
                v-for="(item, index) in items"
                :key="index"
                class="item"
                role="listitem"
            >
                {{ item }}
                <span
                    v-if="suffix !== null && index === selectedIndex"
                    class="suffix"
                >
                    {{ suffix }}
                </span>
            </li>
        </ul>
    </div>
</template>

<script>
/* eslint-disable no-undef */


export default {
        name: 'SlidePicker',
        props: {
            items: {
                type: Array,
                required: true
            },
            suffix: {
                type: String || Object,
                default: null
            },
            initialIndex: {
                type: Number,
                default: 0
            },
            tabIndex: {
                type: Number,
                default: -1
            }
        },
        data () {
            return {
                sly: null,
                selectedIndex: 0
            }
        },
        computed: {
        },
        watch: {
        },
        methods: {
            onValue (index) {
                this.selectedIndex = index
                this.$emit('value', { value: this.items[index], index })
            },
            setPosition (index) {
                this.sly.activatePage(index, true)
            },
            setSlyIndex (index) {
                if (this.sly) {
                    sly.activatePage(index, true)
                }
            },
            onKeyDown (params) {
                const { code } = params
                const { selectedIndex } = this
                if (code === 'ArrowRight' || code === 'ArrowUp') {
                    this.setPosition(selectedIndex + 1)
                } else if (code === 'ArrowLeft' || code === 'ArrowDown') {
                    this.setPosition(selectedIndex - 1)
                }
            }
        },
        async mounted () {
            const options = {
                horizontal: 1,
                itemNav: 'forceCentered',
                smart: 1,
                activateMiddle: 1,
                activateOn: 'click',
                mouseDragging: 1,
                touchDragging: 1,
                releaseSwing: 1,
                startAt: 0,
                scrollBy: 1,
                speed: 300,
                elasticBounds: 1,
                dragHandle: 1,
                dynamicHandle: 1,
                clickBar: 1
            }

            await this.$nextTick()
            const el = this.$el
            const sly = new Sly($(el), options, () => { console.log('hello') }).init()

            if (this.initialIndex) {
                this.selectedIndex = this.initialIndex
            }

            sly.reload()
            sly.on('active', (eventName, itemIndex) => {
                this.onValue(itemIndex)
            })
            this.sly = sly
            if (this.initialIndex) {
                sly.activatePage(this.initialIndex, true)
            }
        }
    }
</script>

<style scoped lang="scss">
    div, ul {
        width: 100%;
        height: 100%;
    }

    .clearfix {
        *zoom: 1;
    }

    .frame {
        overflow: hidden;
        overflow-x: scroll;
        padding-top: 1.5vh;

        ul {
            li {
                height: 30px;
                float: left;
                font-family: SpoqaHanSans-Regular, sans-serif;
                font-size: 20px;

                display: flex;
                justify-content: center;
                align-items: flex-end;
                width: 100px;
                color: #202020;
                vertical-align: middle;
                line-height: 30px;

                &.active {
                    font-size: 32px;
                    color: #3f6fff;
                }

                span.suffix {
                    height: 30px;
                    font-size: 2.5vh;
                    padding-left: 2px;
                    vertical-align: bottom;
                    line-height: 30px;
                }
            }
        }
    }
</style>
